<script setup>
import { ref } from "vue";

defineProps(["faq"]);

const isOpen = ref(false);
</script>
<template>
  <div
    :class="[
      'animation flex max-w-[800px] cursor-pointer flex-col rounded-2xl border border-border bg-white p-8',
      isOpen ? 'gap-6' : 'gap-0',
    ]"
    @click="isOpen = !isOpen">
    <div class="flex items-center justify-between">
      <div class="font-bold text-sm leading-5">{{ faq.question }}</div>
      <i
        :class="[
          'fa-solid fa-plus animation rounded-full border border-border p-4',
          isOpen && '-rotate-45',
        ]"></i>
    </div>
    <p
      :class="[
        isOpen && 'open',
        'answer animation max-h-0 overflow-hidden text-sm text-primaryLight',
      ]">
      {{ faq.answer }}
    </p>
  </div>
</template>
<style scoped>
.answer.open {
  @apply max-h-[200px] overflow-y-auto;
}
</style>
